/* import __COLOCATED_TEMPLATE__ from './code.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { inject as service } from '@ember/service';
import TwoFactorEnrollCodeComponent from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/enroll/code';
let TwoFactorModalEnrollCodeComponent = (_class = class TwoFactorModalEnrollCodeComponent extends TwoFactorEnrollCodeComponent {
  // Override base class error translation labels
  get verificationCodeLengthErrorTLabel() {
    return 'two_factor_modals.enroll.generic.errors.verification_code_length';
  }
  get invalidVerificationCodeErrorTLabel() {
    return 'two_factor_modals.enroll.generic.errors.invalid_verification_code';
  }
  get unknownErrorTLabel() {
    return 'two_factor_modals.enroll.generic.errors.unknown';
  }
  get toastAuthAppAddedTLabel() {
    return 'two_factor_modals.toasts.auth_app_added';
  }
  get toastSmsAddedTLabel() {
    return 'two_factor_modals.toasts.sms_added';
  }
  get toastEnabledTLabel() {
    return 'two_factor_modals.toasts.enabled';
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "marketToasts", _descriptor, this);
  }

  /**
   * @override
   * @see TwoFactorEnrollCodeComponent#handleToast
   */
  handleToast(data, isEnabling) {
    if (isEnabling) {
      this.marketToasts.success(this.intl.t(this.args.tPrefix + this.toastEnabledTLabel));
      return;
    }
    if (data.phone) {
      this.marketToasts.success(data.phone + ' ' + this.intl.t(this.args.tPrefix + this.toastSmsAddedTLabel));
    } else if (data.googleauth) {
      this.marketToasts.success(this.intl.t(this.args.tPrefix + this.toastAuthAppAddedTLabel));
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TwoFactorModalEnrollCodeComponent as default };